import styled from 'styled-components';
import { P, fs, radius, eyebrowLabel, onPhone } from '../../theme/tokens';

export const MODAL_STYLES = {
  mask: { background: 'rgba(11, 20, 38, 0.45)' },
  content: { padding: 0, overflow: 'hidden', borderRadius: 16 },
  header: { background: P.grad, padding: '16px 18px', margin: 0 },
  body: { maxHeight: '72vh', overflowY: 'auto' },
  footer: { margin: 0, padding: '14px 22px', borderTop: `1px solid ${P.line}`, background: P.bgSubtle }
};

export const HeadTitle = styled.div`
  padding-right: 28px;
  ${onPhone} {
    padding-right: 40px;
  }

  h2 {
    margin: ${(p) => (p.$eyebrow ? '4px 0 0' : 0)};
    font-size: ${(p) => p.$size || (p.$icon ? 17 : p.$eyebrow ? 19 : p.$form ? 15 : fs.md)}px;
    ${(p) => p.$size && 'line-height: 1.35;'}
    font-weight: 700;
    color: ${P.white};
    text-wrap: pretty;
  }
  p {
    margin: ${(p) => (p.$icon || p.$size ? 3 : 2)}px 0 0;
    font-size: ${fs.xs}px;
    font-weight: 400;
    color: rgba(255, 255, 255, ${(p) => (p.$icon ? 0.72 : 0.7)});
  }
  small {
    display: block;
    ${eyebrowLabel}
    font-size: 10px;
    color: rgba(255, 255, 255, 0.6);
  }
`;

export const HeadIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  > span {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.12);
    color: ${P.white};
    font-size: 15px;
  }
  > div {
    min-width: 0;
  }
`;

export const HeadRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const HeadTools = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 28px;
  ${onPhone} {
    margin-right: 40px;
  }

  button {
    padding: 4px;
    border: none;
    background: none;
    color: ${P.white};
    font-size: 12px;
    opacity: 0.8;
    cursor: pointer;
  }
`;

export const Block = styled.section`
  padding: 16px 18px;
  border-bottom: 1px solid ${P.line};

  &:last-child {
    border-bottom: none;
  }
  h3 {
    ${eyebrowLabel}
    margin: 0 0 10px;
  }
`;

export const BlockHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;

  h3 {
    margin: 0;
  }
  span {
    font-size: 11px;
    color: ${P.subtle};
  }
  a {
    font-size: ${fs.xs}px;
    font-weight: 600;
    color: ${P.navy};
  }
`;

export const Facts = styled.dl`
  display: grid;
  grid-template-columns: 108px 1fr;
  column-gap: 12px;
  row-gap: 10px;
  margin: 0;
  font-size: ${fs.sm}px;

  dt {
    color: ${P.subtle};
  }
  dd {
    margin: 0;
    min-width: 0;
    font-weight: 600;
    color: ${P.ink};
    overflow-wrap: break-word;
    white-space: pre-line;
  }
  a {
    color: ${P.navy};
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const WorkItem = styled.li`
  padding: 10px 11px;
  border: 1px solid ${P.line};
  border-radius: ${radius.md}px;

  &[href]:hover {
    background: ${P.rowHover};
  }
  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }
  strong {
    font-size: ${fs.sm}px;
    font-weight: 600;
    color: ${P.ink};
    text-wrap: pretty;
  }
  small {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    color: ${P.subtle};
  }
`;

export const Muted = styled.p`
  margin: 0;
  font-size: ${fs.sm}px;
  color: ${P.subtle};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  button:last-child {
    margin-left: auto;
  }
`;
